import { render, staticRenderFns } from "./ViewSavings.vue?vue&type=template&id=4d70056a"
import script from "./ViewSavings.vue?vue&type=script&lang=js"
export * from "./ViewSavings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports